<script setup>
import StepComponent from './StepComponent.vue'

const stepItems = [
  {
    title: 'Complete The Checkout Process',
    text: 'We will ask you a few questions about your business to determine the best filing options for you.',
    id: 1,
    icon: 'fa-credit-card'
  },
  {
    title: 'Verify Business Details',
    text: 'Once the checkout is completed, you will input your beneficial ownership details to complete your filing.',
    id: 2,
    icon: 'fa-file-check'
  },
  {
    title: 'Submit and Relax',
    text: 'Once all steps are completed, relax and let us handle the rest. We will notify you when your filing is complete.',
    id: 3,
    icon: 'fa-face-smile'
  }
]
</script>
<template>
  <div class="container content-space-1">
    <span class="text-cap divider-center">What Happens Next?</span>
    <div class="w-md-75 w-lg-50 text-center mx-md-auto mb-5 mt-5 mb-md-9">
      <h2>Complete Your Filings in 3 Easy Steps</h2>
    </div>
    <div class="border-bottom pb-4 mb-4 text-center">
      <StepComponent :stepItems="stepItems" />
    </div>
  </div>
</template>
